import { makeVar } from '@apollo/client';
import { MyProfileQuery } from '../hooks/api/myProfile/myProfile.generated';

export type ProfileType = MyProfileQuery['myProfile'];
export const profileVar = makeVar<ProfileType | null>(null);
